// import { useEffect, useState } from "react";
// import { NavLink, Link, useLocation } from "react-router-dom";
// import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
// import { siteConfig } from "../data/siteConfig";
// import "../styles/Navbar.css";

// const navLinks = [
//   { to: "/", label: "Home" },
//   { to: "/about", label: "About Us" },
//   { to: "/rooms", label: "Rooms" },
//   { to: "/amenities", label: "Amenities" },
//   { to: "/gallery", label: "Gallery" },
//   { to: "/contact", label: "Contact" },
// ];

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [open, setOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 50);
//     onScroll();
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   // Close mobile menu on route change
//   useEffect(() => { setOpen(false); }, [location.pathname]);

//   return (
//     <header className={`navbar ${scrolled || open ? "scrolled" : ""}`}>
//       <div className="container nav-inner">
//         <Link to="/" className="logo">
//           <span className="logo-badge">U</span>
//           <span className="logo-text">
//             <strong>USHA <span>RESORT</span></strong>
//             <small>Patna · Bihar</small>
//           </span>
//         </Link>

//         <nav className={`nav-links ${open ? "open" : ""}`}>
//           {navLinks.map((link) => (
//             <NavLink
//               key={link.to}
//               to={link.to}
//               className={({ isActive }) => (isActive ? "active" : "")}
//             >
//               {link.label}
//             </NavLink>
//           ))}
//           <a href={siteConfig.phoneHref} className="nav-phone mobile-only">
//             <FaPhoneAlt /> {siteConfig.phone}
//           </a>
//         </nav>

//         <div className="nav-cta">
//           <a href={siteConfig.phoneHref} className="nav-phone desktop-only">
//             <FaPhoneAlt /> {siteConfig.phone}
//           </a>
//           <button className="nav-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
//             {open ? <FaTimes /> : <FaBars />}
//           </button>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;


import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import { siteConfig } from "../data/siteConfig";
import "../styles/Navbar.css";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/rooms", label: "Rooms" },
  { to: "/lawns", label: "Lawns" }, 
  { to: "/banquet", label: "Banquet Hall" },
  { to: "/amenities", label: "Amenities" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [logoError, setLogoError] = useState(false); // 👈 PNG fallback state
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Show PNG if available, otherwise fall back to "U" letter badge
  const showLogoImage = siteConfig.logo && !logoError;

  return (
    <header className={`navbar ${scrolled || open ? "scrolled" : ""}`}>
      <div className="container nav-inner">
        <Link to="/" className="logo" aria-label="USHA Resort — Home">
          {showLogoImage ? (
            <img
              src={siteConfig.logo}
              alt="USHA Resort Logo"
              className="logo-img"
              onError={() => setLogoError(true)} // 👈 auto-fallback to "U"
            />
          ) : (
            <span className="logo-badge">U</span>
          )}

          {/* Hide the text if the PNG already contains the resort name */}
          {!showLogoImage || siteConfig.logoText !== false ? (
            <span className="logo-text">
              </span>
          ) : null}
        </Link>

        <nav className={`nav-links ${open ? "open" : ""}`}>
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {link.label}
            </NavLink>
          ))}
          <a href={siteConfig.phoneHref} className="nav-phone mobile-only">
            <FaPhoneAlt /> {siteConfig.phone}
          </a>
        </nav>

        <div className="nav-cta">
          <a href={siteConfig.phoneHref} className="nav-phone desktop-only">
            <FaPhoneAlt /> {siteConfig.phone}
          </a>
          <button className="nav-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;